import { Tag } from 'antd'
import { useTranslation } from 'react-i18next'

import type { FulfillmentOrderAnnotationRoot } from '@repo/sdk'

interface FoAnnotationBadgeProps {
  annotation: FulfillmentOrderAnnotationRoot
  style?: React.CSSProperties
}

const annotationColors: Record<Exclude<FulfillmentOrderAnnotationRoot, 'NONE'>, string> = {
  PARTIAL_CANCEL: 'orange',
  PARTIAL_RETURN: 'volcano',
  PARTIAL_CANCEL_AND_RETURN: 'red',
}

export function FoAnnotationBadge({
  annotation,
  style,
}: FoAnnotationBadgeProps): React.JSX.Element | null {
  const { t } = useTranslation()

  if (annotation === 'NONE') return null

  const labelMap: Record<Exclude<FulfillmentOrderAnnotationRoot, 'NONE'>, string> = {
    PARTIAL_CANCEL: t('common.foAnnotation.partialCancel'),
    PARTIAL_RETURN: t('common.foAnnotation.partialReturn'),
    PARTIAL_CANCEL_AND_RETURN: t('common.foAnnotation.partialCancelAndReturn'),
  }

  return (
    <Tag color={annotationColors[annotation]} style={style}>
      {labelMap[annotation]}
    </Tag>
  )
}
